import React from 'react'
import Bredcrum from '../../common/Bredcrum'
import ContactCta from '../../Reusable/ContactCta'
import Accordion from '../Faqs/Accordian';
import { config } from '../config';

const questions = [
    {
        question: 'How long is a practical driving test?',
        answer: "The practical driving test typically lasts around 40 minutes. During this time, you'll be assessed on various aspects of your driving ability, including your control of the vehicle, ability to follow road signs and markings, awareness of other road users, and your overall safety on the road."
    },
    {
        question: 'How much does a practical driving test cost?',
        answer: "As of our last update, the cost of a practical driving test in the UK is £62 on weekdays and £75 on weekends and evenings. However, please note that these prices may vary, so we recommend checking the latest fees on the official government website."
    },
    {
        question: 'How many faults are allowed during the test?',
        answer: "You're allowed to make up to 15 minor driving faults during the test and still pass. However, if you commit one serious or dangerous fault, you'll fail the test. It's essential to familiarise yourself with the criteria for minor, serious, and dangerous faults to ensure you're well-prepared on the day of your test."
    },
    {
        question: 'Can I use my own car for the practical driving test?',
        answer: "Yes, you can use your own car for the test as long as it meets the DVLA's requirements for safety, insurance, and roadworthiness. Your vehicle must also have a valid MOT certificate, and L-plates must be displayed prominently during the test."
    },
    {
        question: "How long will it take to get my full driver's licence after passing the practical test?",
        answer: "Once you've passed your practical driving test, you can apply for your full driver's licence online or by post. Processing times may vary, but you should receive your licence within a few weeks. In the meantime, you can continue driving with your provisional licence."
    }
];

const AboutPracticalCourse = () => {

    return (
        <>
            <Bredcrum
                heading={'Your Practical Driving Test'}
                path={[
                    { name: 'Practical Driving Test', path: 'about-practical-test' },
                ]}
            />

            <div className=' my-5 pb-md-5'>
                <div className='auto-container p-md-5 p-4 pb-4' style={{ backgroundColor: '#f2f2f2' }}>
                    <div className="row">
                        <div className="sec-title ">
                            <h2 className='mb-4 '>Your Practical Driving Test</h2>
                            <p className='d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                As you gear up for your practical driving test, you might find yourself with questions about the road ahead. At Acclaim Driving, we understand the importance of feeling prepared and supported throughout this journey. We'll walk you through everything you need to know about the practical driving test in the UK, from its duration and cost to what happens on the day.
                            </p>

                            <h4 className='my-4 '>Book your Practical Driving Test</h4>

                            <p className='mt-3 d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                To book your practical driving test, you can visit the official government website or call the Driver and Vehicle Standards Agency (DVSA) booking line. You'll need your provisional driving licence number and a valid payment method to complete the booking.
                            </p>
                            <p className='mt-3 d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                If you learn with Acclaim, booking is as simple as giving us a call. We have access to the available tests along with your instructor's availability so that we can book accordingly.
                            </p>

                            <h4 className='my-4 '>What to Expect on the Day</h4>

                            <p className='mt-3 d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                On the day of your practical driving test, you'll meet your examiner at the designated test centre. Make sure you arrive in plenty of time to complete any necessary paperwork and familiarise yourself with the testing environment.
                            </p>

                            <h4 className='my-4 '>Remember!</h4>

                            <p className='mt-3 d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                Bring your provisional driving licence, as well as any glasses or contact lenses if you need them for driving. You should also bring your theory test pass certificate and confirmation of your practical driving test booking. You won’t be able to take your driving test without these documents!
                            </p>

                            <h4 className='my-4 '>What happens after the driving test?</h4>

                            <p className='mt-3 d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                If you've passed, congratulations! You'll receive your pass certificate, and you can start enjoying the freedom of driving on your own.
                            </p>

                            <p className='mt-3 d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                If you're unsuccessful, don't be discouraged! Your examiner will provide you with feedback to help you improve, and you can book another test whenever you're ready.*
                            </p>

                            <h4 className='my-4 '>Preparing for the Test</h4>

                            <p className='mt-3 d-flex'>
                                <i className='bi bi-chevron-double-right me-3 text-green'></i>
                                In addition to practical lessons, it's essential to study the Highway Code and familiarise yourself with the rules of the road. Practice mock tests to simulate the test environment and identify any areas where you may need improvement.
                            </p>

                            <div className='row justify-content-between mt-5 pt-3'>

                                <div className='col-md-12'>
                                    <h4 className='mb-4 '>FAQs</h4>
                                    <Accordion questions={questions} className={'ps-md-4 ps-3 pe-3 py-3'} />
                                </div>

                                {/* <div className="col-md-5 mt-md-0 mt-5 ">
                                    <div>
                                        <h4 className='mb-4 px-md-3 '>We’ll get in touch with you soon</h4>

                                        <div className='contact-section pt-2'>
                                            <div className='form-inner ps-0 pe-0 pb-0 pt-0 mx-md-3'>
                                                <form action="" className='buy_form w-100'>
                                                    <div className="row clearfix">
                                                        <div className=" col-sm-12 form-group">
                                                            <input
                                                                type="text"
                                                                name="fname"
                                                                placeholder="Full Name"
                                                                required=""
                                                                aria-required="true"
                                                            />
                                                        </div>

                                                        <div className="col-lg-12 col-md-6 col-sm-12 form-group">
                                                            <input
                                                                type="email"
                                                                name="email"
                                                                placeholder="Email Address"
                                                                required=""
                                                                aria-required="true"
                                                            />
                                                        </div>

                                                        <div className="  col-sm-12 form-group">
                                                            <input
                                                                type="text"
                                                                name="phone"
                                                                required=""
                                                                placeholder="Phone Number"
                                                                aria-required="true"
                                                            />
                                                        </div>

                                                        <div className="col-lg-12 col-md-6 col-sm-12 form-group">
                                                            <textarea
                                                                type="text"
                                                                name="address"
                                                                required=""
                                                                placeholder="Message"
                                                                aria-required="true"
                                                            />
                                                        </div>

                                                        <div className="btn-box text-center mt-3">
                                                            <button className="theme-btn btn-two w-100" >
                                                                Send Message
                                                                <i className='bi bi-arrow-right ms-2 fs-6'></i>
                                                            </button>
                                                        </div>

                                                    </div>
                                                </form>

                                            </div>
                                        </div>
                                    </div>
                                </div> */}

                                <div className="btn-box text-center mt-3">
                                    <a href={`${config.appUrl}contact-us`} className="theme-btn btn-two mt-3" type='button'>
                                        Send Message
                                        <i className='bi bi-arrow-right ms-2 fs-6'></i>
                                    </a>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <ContactCta />
        </>
    )
}

export default AboutPracticalCourse